import React from 'react'
import { Box, Typography } from '@mui/material'


export default function providersAvailabilityColumn() {

	return {
		name: 'providersNames',
		label: 'Providers available',
		options: {
			setCellProps: () => ({
				sx: { maxWidth: 100 }
			}),
			customBodyRowRenderLite: value => <Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "start"
				}}>
				<Typography>{!!value?.length ? value?.join(', ') : "Any"}</Typography>
			</Box>,
		}
	}
}
